<template>
  <v-dialog :value="open" persistent max-width="500px">
    <v-card>
      <v-card-text>
        <v-container>
          <h1>{{ $t('option.editOption') }}</h1>
        </v-container>
      </v-card-text>

      <v-card-text>
        <v-text-field
          v-model="option.name"
          outlined
          :label="$t('global.inputNaturalLanguage')"
          counter="100"
          maxLength="100"
          required
        />
        <v-text-field
          v-model="option.prolog"
          outlined
          :label="$t('global.inputLogicalLanguage')"
          counter="200"
          maxLength="200"
          required
        />
      </v-card-text>

      <v-card-actions>
        <div class="ma-auto">
          <v-btn
            color="primary"
            tile
            @click="confirmEdit"
            class="mx-1"
          >
            {{ $t('global.validate') }}
          </v-btn>
          <v-btn
            color="ternary"
            dark
            tile
            @click="cancel"
            class="mx-1"
          >
            {{ $t('global.cancel') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditOptionDialog',

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    confirmEdit: {
      type: Function,
      required: true,
    },
    option: {
      type: Object,
      required: true,
    },
  },

  methods: {
    cancel () {
      this.$emit('cancel-option-edition');
    },
  },
};
</script>